import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Location\GetLocationActivitiesByIdController::__invoke
* @see app/Http/Controllers/Location/GetLocationActivitiesByIdController.php
* @route '/api/location/{location}/activities'
*/
const GetLocationActivitiesByIdController = (args: { location: string | number | { id: string | number } } | [location: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetLocationActivitiesByIdController.url(args, options),
    method: 'get',
})

GetLocationActivitiesByIdController.definition = {
    methods: ["get","head"],
    url: '/api/location/{location}/activities',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Location\GetLocationActivitiesByIdController::__invoke
* @see app/Http/Controllers/Location/GetLocationActivitiesByIdController.php
* @route '/api/location/{location}/activities'
*/
GetLocationActivitiesByIdController.url = (args: { location: string | number | { id: string | number } } | [location: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { location: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { location: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            location: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        location: typeof args.location === 'object'
        ? args.location.id
        : args.location,
    }

    return GetLocationActivitiesByIdController.definition.url
            .replace('{location}', parsedArgs.location.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Location\GetLocationActivitiesByIdController::__invoke
* @see app/Http/Controllers/Location/GetLocationActivitiesByIdController.php
* @route '/api/location/{location}/activities'
*/
GetLocationActivitiesByIdController.get = (args: { location: string | number | { id: string | number } } | [location: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetLocationActivitiesByIdController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Location\GetLocationActivitiesByIdController::__invoke
* @see app/Http/Controllers/Location/GetLocationActivitiesByIdController.php
* @route '/api/location/{location}/activities'
*/
GetLocationActivitiesByIdController.head = (args: { location: string | number | { id: string | number } } | [location: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetLocationActivitiesByIdController.url(args, options),
    method: 'head',
})

export default GetLocationActivitiesByIdController